import type { Config, tAPI } from "./API";

// API Feedback Report or Bugs static class
const apiBaseFeedbackForm = "/feedback-reports";
export default class FeedbackForm {
  // Send feedback form (always JSON — file uploaded via Storage beforehand)
  static SendFeedbackForm(
    api: tAPI,
    data: object,
    _isUpload: boolean = false,
    config?: Config
  ) {
    return api.POST(`${apiBaseFeedbackForm}`, data, config);
  }
}
